import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-mymo-plus-callback.component.scss";
var FormItemMymoPlusCallback = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMymoPlusCallback, _super);
    function FormItemMymoPlusCallback(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemMymoPlusCallback.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.buttonCallMeBack = this.element.querySelector(".js-myMoPlusCallMePc__button--confirmCustomer");
        this.buttonOpenOnline = this.element.querySelector(".js-myMoPlusOpenOnlinePc__button--confirmCustomer");
        this.displayModal = this.element.querySelector(".modal__dialog");
        this.displayTitle = this.element.querySelector(".apply-now__title--module-title");
        this.buttonSubmit = Array.from(this.element.querySelectorAll(".js-mymo-plus-account-call-me-backSubmit_button"));
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayMessageOptions = this.form.querySelector(".form-container__options");
            this.displayMessageSuccess = this.element.querySelector(".form-container__success");
            this.displayMessageFail = this.element.querySelector(".form-container__error");
            this.displayFields = this.form.querySelector(".form-container__fields");
        }
    };
    FormItemMymoPlusCallback.prototype.bindEvents = function () {
        var _this = this;
        var formModal = this.element
            .closest(".modal")
            .querySelector(".modal__dialog--small");
        if (formModal) {
            formModal.classList.remove("modal__dialog--small");
            formModal.classList.add("modal__dialog--large");
        }
        this.checkCurrentPageUrl(formModal);
        this.buttonSubmit.map(function (item) {
            return item.addEventListener("click", function (event) {
                var formFields = _this.form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    // screens
                    _this.showDisplayView("loader");
                    // Check if gRecaptcha is enabled for this form
                    if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                        var gToken_1 = '';
                        try {
                            // Attempt to get recaptcha token
                            grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var err_1;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                        case 1:
                                            gToken_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_1 = _a.sent();
                                            // Log error
                                            console.log("Unable to retrieve gRecaptcha Token");
                                            console.log(err_1);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            // Set recaptcha token
                                            this.gRecaptchaToken = gToken_1;
                                            this.submitForm();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        catch (err) {
                            // Log error
                            console.log("Unable to retrieve gRecaptcha Token");
                            console.log(err);
                            _this.submitForm();
                        }
                    }
                    else {
                        _this.submitForm();
                    }
                }
            });
        });
        this.buttonCallMeBack.addEventListener("click", function (event) {
            if (formModal) {
                formModal.classList.remove("modal__dialog--large");
                formModal.classList.add("modal__dialog--small");
            }
            _this.showDisplayView("fields");
        });
        this.buttonOpenOnline.addEventListener("click", function (event) {
            window.open("https://onlinebanking.standardbank.co.za/#/productselection", "_self");
            window.opener = null;
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
    };
    FormItemMymoPlusCallback.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemMymoPlusCallback.prototype.checkCurrentPageUrl = function (formModal) {
        var url = window.location.href.toLowerCase();
        if (url.includes("mymoplusaccount")) {
            if (formModal) {
                formModal.classList.remove("modal__dialog--large");
                formModal.classList.add("modal__dialog--small");
            }
            this.showDisplayView("fields");
        }
    };
    FormItemMymoPlusCallback.prototype.submitForm = function () {
        var _this = this;
        var firstName = this.form.querySelector("input[name=firstName]");
        var lastName = this.form.querySelector("input[name=lastName]");
        var idNumber = this.form.querySelector("input[name=idNumber]");
        var cellNumber = this.form.querySelector("input[name=phoneNumber]");
        var altCellNumber = this.form.querySelector("input[name=alternativePhoneNumber]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var firstNameValue = firstName ? firstName.value : "";
        var lastNameValue = lastName ? lastName.value : "";
        var fullName = firstNameValue + " " + lastNameValue;
        var requestData = {
            fullName: fullName,
            idNum: idNumber ? idNumber.value : "",
            description: "MyMo Plus Account",
            contact: cellNumber ? cellNumber.value : "",
            contact2: altCellNumber ? altCellNumber.value : "",
            timeToCall: _dateTime,
            dataPrivacyConsent: _popiaConsent
                ? _popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-boarders"),
            recaptchaToken: this.gRecaptchaToken
        };
        var url = this.baseUrl + "/services/SubmitApplicationForm.jsp";
        var _config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        this.formsService
            .postForm(url, this.http.serialiseObject(requestData), _config)
            .then(function (response) {
            // service ok
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", response.data, false, "", "", cellNumber.value);
                _this.showDisplayView("success");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemMymoPlusCallback.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayMessageFail.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displayMessageSuccess.classList.add("hidden");
        this.displayMessageOptions.classList.add("hidden");
        switch (pDisplay) {
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displayMessageSuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayMessageFail.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemMymoPlusCallback;
}(Base));
export { FormItemMymoPlusCallback };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mymo-plus-callback/form-item-mymo-plus-callback.component.ts
// module id = 959
// module chunks = 0